import React, { useContext } from 'react'
import PrimaryButton from '../../../../global/components/buttons/primary-button/PrimaryButton'
import { TechnicianModal } from '../../technician-modal/components/container-modal/TechnicianModal'
import OnCallTechnicianManagerModal from '../../on-call-technician-manager/components/OnCallTechnicianManagerModal'
import styles from './styles.module.css'
import hasPermission from '../../../../global/utils/user/has-permission'
import { UserContext } from '../../../../base/components/base-container/BaseContainer'
import { PERMISSIONS } from '../../../../global/constants/permissions'

export default function TechnicianPageHeader() {
  const { user } = useContext(UserContext)
  const [open, setOpen] = React.useState(false)
  const [onCallModalOpen, setOnCallModalOpen] = React.useState(false)
  function handleOpen() {
    setOpen(true)
  }

  function handleClosed() {
    setOpen(false)
  }
  function handleOnCallModalOpen() {
    setOnCallModalOpen(true)
  }

  function handleOnCallModalClosed() {
    setOnCallModalOpen(false)
  }

  return (
    <div className={styles.techPageHeaderContainer}>
      <div className={styles.inputsContainer} />
      <div className={styles.inputsContainer}>
        <PrimaryButton
          buttonName='New Technician'
          onClick={handleOpen}
          disabled={
            !hasPermission(user).allow(
              PERMISSIONS.TECHNICIANS.CATEGORY,
              PERMISSIONS.TECHNICIANS.ENTRIES.NEW_TECHNICIAN_BUTTON.NAME,
            )
          }
        />
        <PrimaryButton
          buttonName='On-Call Technician Manager'
          onClick={handleOnCallModalOpen}
          disabled={
            !hasPermission(user).view(
              PERMISSIONS.TECHNICIANS.CATEGORY,
              PERMISSIONS.TECHNICIANS.ENTRIES.ON_CALL_TECHNICIAN_MANAGER.NAME,
            )
          }
        />
      </div>
      {open && (
        <TechnicianModal
          isOpen={open}
          handleClosed={handleClosed}
        />
      )}
      {onCallModalOpen && (
        <OnCallTechnicianManagerModal
          isOpen={onCallModalOpen}
          handleClosed={handleOnCallModalClosed}
        />
      )}
    </div>
  )
}
